import axios from 'axios';

export const BASE_API_URL = '/api/';

class Request {
  private readonly defaultConfig: any;
  private basePath: string;

  constructor(basePath = '') {
    this.defaultConfig = {
      headers: {
        'content-type': 'application/json',
      },
    };
    this.basePath = BASE_API_URL + basePath;
  }

  public get(url: string, config = {}) {
    const completeConfig = {
      ...this.defaultConfig,
      ...config,
      method: 'get',
      data: { data: null },
    };
    return this.request(url, completeConfig);
  }

  public post(url: string, data?: any, config = {}) {
    const completeConfig = {
      ...this.defaultConfig,
      ...config,
      method: 'post',
      data,
    };
    return this.request(url, completeConfig);
  }

  public delete(url: string, config = {}) {
    const completeConfig = {
      ...this.defaultConfig,
      ...config,
      method: 'delete',
    };
    return this.request(url, completeConfig);
  }

  private request = async (url: string, { returnRaw, ...config }: any) => {
    try {
      return axios(this.basePath + url, config).then((resp: any) => {
        if (!resp) {
          return false;
        }
        return returnRaw ? resp : resp.data;
      });
    } catch (err) {
      return err;
    }
  };
}

export default Request;
